import { defineMessages } from "react-intl";

export default defineMessages({
  waitingForBankTransfer: {
    id: "confirmationModal.waitingForBankTransfer",
    defaultMessage: "Waiting for bank transfer",
  },
  paymentConfirmed: {
    id: "confirmationModal.paymentConfirmed",
    defaultMessage: "Payment confirmed",
  },
  paymentConfirmedInformations: {
    id: "confirmationModal.paymentConfirmedInformations",
    defaultMessage:
      "Last thing - help { serviceProviderName } by giving your feedback on this service",
  },
  continue: {
    id: "confirmationModal.continue",
    defaultMessage: "Continue",
  },
  headsUpNewTask: {
    id: "confirmationModal.headsUpNewTask",
    defaultMessage:
      "Head's up! <b>{serviceProviderName} has created a new task for you</b> based on the work that was just completed.",
  },
  acceptOrDeclineNextStep: {
    id: "confirmationModal.acceptOrDeclineNextStep",
    defaultMessage: "Accept or decline on the next step",
  },
  goToTask: {
    id: "confirmationModal.goToTask",
    defaultMessage: "Go to task",
  },
});
